import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import classNames from "classnames";
import LockClosed from "../../icons/lock-closed.svg";
import LockOpen from "../../icons/lock-open.svg";
import { DEPRECATED_Typography } from "../DEPRECATED_Typography";
import { Icon } from "../Icon";
import { TierBadge } from "../TierBadge";
import { TimeLimitedBadge } from "../TimeLimitedBadge";
import styles from "./VirtualPrizeBadges.module.scss";
export const VirtualPrizeBadges = ({ color, hasLimitedOfferBadge, newBadgeLabel, showNewBadge, isTierRestricted, tier, tierRestrictedLabel, outOfStockLabel, isOutOfStock, timeLimitedBadgeLabel, isMoreThanOneDay, isPlacedInSmallBox, }) => {
    const textColor = color === "white" ? "white" : "grey-3";
    const getElementClasses = ({ isOutOfStock, isLabel, isLeftPlacement, isIcon, isWrapper, }) => {
        const isLeft = isLeftPlacement === true;
        const isRight = isLeftPlacement === false;
        const isBlackIcon = color === "black";
        return classNames({
            [styles.iconWhite]: isIcon && !isBlackIcon,
            [styles.iconDark]: isIcon && isBlackIcon,
            [styles.right]: isRight,
            [styles.rightSmallBox]: isRight && isPlacedInSmallBox,
            [styles.left]: isLeft,
            [styles.leftSmallBox]: isLeft && isPlacedInSmallBox,
            [styles.label]: isLabel,
            [styles.wrapper]: isWrapper,
            [styles.outOfStock]: isOutOfStock,
            [styles.outOfStockDark]: isOutOfStock && isBlackIcon,
        });
    };
    if (isTierRestricted) {
        return (_jsx(TierBadge, { className: getElementClasses({ isLeftPlacement: false }), tier: tier, text: tierRestrictedLabel }));
    }
    if (isOutOfStock) {
        return (_jsxs("div", { className: getElementClasses({ isLeftPlacement: false, isWrapper: true }), children: [_jsx(Icon, { className: getElementClasses({ isIcon: true }), component: LockClosed, width: "20px", height: "22px" }), _jsx(DEPRECATED_Typography, { className: getElementClasses({ isOutOfStock: true, isLabel: true }), type: "table-content", color: textColor, dataTestid: "outOfStockBadge", children: outOfStockLabel })] }));
    }
    return (_jsxs(_Fragment, { children: [!hasLimitedOfferBadge && showNewBadge && (_jsx(DEPRECATED_Typography, { type: "table-content", color: textColor, dataTestid: "newPrizeBadge", className: getElementClasses({ isLabel: true, isLeftPlacement: true }), children: newBadgeLabel })), _jsx(TimeLimitedBadge, { isMoreThanOneDay: isMoreThanOneDay, isDisabled: !hasLimitedOfferBadge, color: textColor, label: timeLimitedBadgeLabel, className: getElementClasses({ isLeftPlacement: true }) }), _jsx(Icon, { className: getElementClasses({ isLeftPlacement: false, isIcon: true }), component: LockOpen, width: "20px", height: "22px" })] }));
};
//# sourceMappingURL=VirtualPrizeBadges.js.map